/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ExecutionEnvironment =
  | "Test"
  | "Prod"
  | "ProdNe"
  | "ProdWe"
  | "Spiir"
  | "SpiirTest"
  | "SpiirNe"
  | "SpiirWe"
  | "SpiirAws"
  | "SquadExpansionProd"
  | "SandboxSquirrel"
  | "SandboxCapybara"
  | "SandboxMousedeer"
  | "SandboxPlatypus"
  | "SandboxSloth";

export const ExecutionEnv: { id: ExecutionEnvironment; label: string }[] = [
  { id: "Prod", label: "Prod" },
  { id: "Test", label: "Test" },
  { id: "SandboxCapybara", label: "Capybara - Member Testing Facility" },
  { id: "SquadExpansionProd", label: "Koala - Member Testing Facility" },
  { id: "SandboxMousedeer", label: "Mousedeer - Member Testing Facility" },
  { id: "SandboxPlatypus", label: "Platypus - Member Testing Facility" },
  { id: "SandboxSloth", label: "Sloth - Member Testing Facility" },
  { id: "SandboxSquirrel", label: "Squirrel - Member Testing Facility" },
  { id: "SpiirTest", label: "Spiir Test (AWS)" }
];

export const ProdRegionsExecutionEnvtTypes: { id: ExecutionEnvironment; label: string }[] = [
    { id: "ProdNe", label: "Prod Ne" },
    { id: "ProdWe", label: "Prod We" },
];

export const SpiirExecutionEnvType: { id: ExecutionEnvironment; label: string }[] = [
    { id: "Spiir", label: "Spiir Azure" },
    { id: "SpiirAws", label: "Spiir AWS" },
];

export const SpiirRegionsExecutionEnvTypes: { id: ExecutionEnvironment; label: string }[] = [
    { id: "SpiirNe", label: "Spiir Ne" },
    { id: "SpiirWe", label: "Spiir We" },
];